import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { noop, capitalize, get } from 'lodash';

import Modal from '../../../common/Modal';
import Queue from '../../../queue/QueueContainer';
import OverlaySpinner from '../../../common/OverlaySpinner';
import DirtyFilterOverlay from '../components/DirtyFilterOverlay';
import { SubSummary } from '../../../register/summary/Summary/Sale';
import RowExpanded from '../../../register/summary/Summary/SummaryRowExpanded';
import { isReceipt, getTableColumns } from '../../../register/summary/Summary/utils';
import { getActiveType } from '../../../auth/selectors';

const PAGE_SIZE = 10;

const RefundsAndDiscounts = ({
  open,
  close,
  items,
  title,
  expanded,
  setExpanded,
  isLoading,
  csvJobName,
  filters,
  activeType,
}) => (
  <Modal
    display-if={open}
    title={capitalize(title)}
    close={close}
    showCloseButton
    automationIdPart="refundsAndDiscountsModal"
  >
    <div className="c-refunds-and-discounts u-p- u-pb">
      <div className="u-mr0 large-and-up-mr- u-mb u-mt">
        <Queue
          name="reports"
          btnLabel="Export to CSV"
          btnClass="c-btn c-btn--medium"
          jobName={csvJobName}
          label={capitalize(title)}
          filters={filters}
        />
      </div>
      <div className="u-position-relative">
        <ReactTable
          display-if={items.length && !isLoading}
          defaultSorted={[{ id: 'time' }]}
          expanded={expanded}
          showPagination={items.length > PAGE_SIZE}
          defaultPageSize={PAGE_SIZE}
          minRows={0}
          className="ReactTable--row-spacing-only c-summary-table"
          data={items}
          columns={getTableColumns(activeType)}
          getTrProps={(state, rowInfo) => ({
            onClick: () => {
              setExpanded({
                [rowInfo.viewIndex]: !expanded[rowInfo.viewIndex],
              });
            },
            className: 'is-clickable',
            'data-automation-id': `dataRow:refundsAndDiscountsModal:${rowInfo.viewIndex}`,
          })}
          SubComponent={(props) => {
            const original = get(props, 'original');
            if (isReceipt(original)) {
              return <SubSummary items={original.items} onItemClick={noop} />;
            }

            return <RowExpanded item={original.items[0]} />;
          }}
        />
        <p className="u-text-center u-mb-auto" display-if={!isLoading && !items.length}>
          No {title} found for selected dates
        </p>
        <DirtyFilterOverlay display-if={!isLoading} />
        <OverlaySpinner display-if={isLoading} />
      </div>
    </div>
  </Modal>
);

RefundsAndDiscounts.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  expanded: PropTypes.object.isRequired,
  setExpanded: PropTypes.func.isRequired,
  csvJobName: PropTypes.string.isRequired,
  activeType: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({ activeType: getActiveType(state) });

export default connect(mapStateToProps)(RefundsAndDiscounts);
